import React, {useContext, useState} from 'react';
import {USE_CASE_MAP} from "../util/Constants";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import {FormattedMessage, injectIntl} from "react-intl";
import Button from "@amzn/meridian/button";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Select, {SelectOption} from "@amzn/meridian/select";
import {GlobalStateContext} from "../global/context/GlobalStateContext";

const ChangeDeviceUseCaseModal = (props) => {

    const {formatMessage} = props.intl;
    const {open, setOpen, selectedDevice, setSelectedDevice, dispatch} = props;
    const [selectedUseCase, setSelectedUseCase] = useState('');
    const {showWarning, showCustomAlert} = useContext(GlobalStateContext);

    const onClickConfirm = () => {
        if (selectedUseCase) {
            showWarning(`Are you sure you want to change use case to ${selectedUseCase.displayText} for device with ${selectedDevice.mac} MAC address`, () => {
                changeUseCase(selectedDevice.mac, selectedUseCase.useCase);
                onCloseModal();
            });
        }
    };

    const onCloseModal = () => {
        setOpen(false);
        setSelectedDevice('');
        resetInputState();
    };

    function resetInputState() {
        setSelectedUseCase('');
    }

    const changeUseCase = (mac, targetUseCase) => {
        dispatch({type: 'CHANGE_USECASE', data: {dispatcher: props.dispatch, mac: mac, useCase: targetUseCase, showCustomAlert}})
    }

    return (
        <Modal
            title={formatMessage({id: "device.usecase_change_modal"})}
            open={open}
            onClose={onCloseModal}
            scrollContainer="viewport"
            closeLabel="Close"
            bodySpacingInset="medium">
            <Row width={"40%"}>
                <Column width="fill" spacing={"medium"} spacingInset={"medium"}>
                    <Text tag="label" type="b200" color="primary" htmlFor="my-input">
                        { selectedUseCase ?
                            <FormattedMessage id="modal.confirmchangeusecase"
                                              defaultMessage="Please confirm the new Thin Client use case you have selected."/>
                            : <FormattedMessage id="modal.selectnewusecase"
                                                defaultMessage="Please select new use case for Thin Client."/>
                        }
                    </Text>
                    <Column spacing="500">
                        <Select id="select.usecase"
                                placeholder={<FormattedMessage id="modal.selectusecase" defaultMessage="Select use case"/>}
                                value={selectedUseCase} onChange={setSelectedUseCase} width={300}>
                            <option value="">Change Use Case</option>
                            {Object.keys(USE_CASE_MAP).filter((useCase) => selectedDevice.useCase !== USE_CASE_MAP[useCase].assetUseCase)
                                .map((useCase) => (
                                    <SelectOption key={useCase} value={USE_CASE_MAP[useCase]}
                                                  label={USE_CASE_MAP[useCase].displayText}/>
                            ))}
                        </Select>
                    </Column>
                </Column>
            </Row>
            <ModalFooter>
                <Row alignmentHorizontal="right" widths="fit">
                    <Button type="secondary" size="medium" onClick={onCloseModal}>
                        <FormattedMessage id="modal.cancel" defaultMessage="Cancel"/>
                    </Button>
                    <Button type="primary" size="medium"
                            onClick={() => onClickConfirm()}>
                        <FormattedMessage id="modal.confirm" defaultMessage="Confirm"/>
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    );
};

export default injectIntl(ChangeDeviceUseCaseModal);



// WEBPACK FOOTER //
// ./src/components/commonui/ChangeDeviceUseCaseModal.js